var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import cx from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Done from '@mui/icons-material/Done';
import { withInput } from '../Input/with-input';

var useStyles = makeStyles(function () {
  return {
    visibility: {
      visibility: 'hidden'
    }
  };
});

var LefttIcon = function LefttIcon(_ref) {
  var Icon = _ref.Icon;
  return React.createElement(Icon, null);
};

LefttIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  Icon: PropTypes.object
} : {};

var RightIcon = function RightIcon(_ref2) {
  var onSubmit = _ref2.onSubmit,
      _ref2$Icon = _ref2.Icon,
      Icon = _ref2$Icon === undefined ? Done : _ref2$Icon;
  return React.createElement(
    IconButton,
    { color: 'primary', onClick: function onClick() {
        return onSubmit();
      }, size: 'small' },
    React.createElement(Icon, null)
  );
};

RightIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  Icon: PropTypes.object,
  onSubmit: PropTypes.func,
  classes: PropTypes.object
} : {};

export var MyInput = function MyInput(_ref3) {
  var _cx;

  var id = _ref3.id,
      label = _ref3.label,
      name = _ref3.name,
      placeholder = _ref3.placeholder,
      leftIcon = _ref3.leftIcon,
      rightIcon = _ref3.rightIcon,
      value = _ref3.value,
      type = _ref3.type,
      onChange = _ref3.onChange,
      onSubmit = _ref3.onSubmit,
      fullWidth = _ref3.fullWidth,
      withValidationIcon = _ref3.withValidationIcon,
      textFieldProps = _ref3.textFieldProps,
      inputProps = _ref3.inputProps,
      endAdornment = _ref3.endAdornment;

  var classes = useStyles();
  var startAdornment = R.isNil(leftIcon) ? null : React.createElement(
    InputAdornment,
    { position: 'start' },
    React.createElement(LefttIcon, { Icon: leftIcon })
  );
  var endMyadornment = R.or(withValidationIcon, !R.isNil(rightIcon)) ? React.createElement(
    InputAdornment,
    { position: 'end', className: cx((_cx = {}, _cx[classes.visibility] = R.isEmpty(value), _cx)) },
    React.createElement(RightIcon, { onSubmit: onSubmit, Icon: rightIcon })
  ) : null;

  var onEnterLabel = function onEnterLabel(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (R.is(Function, onSubmit)) {
        onSubmit();
      }
    }
  };

  return React.createElement(TextField, _extends({
    'data-testid': 'input-test-id',
    margin: 'dense',
    fullWidth: fullWidth,
    id: id,
    name: name,
    type: type,
    label: label,
    value: value,
    variant: 'outlined',
    placeholder: placeholder,
    onChange: onChange,
    onKeyPress: onEnterLabel,
    InputProps: {
      startAdornment: startAdornment,
      endAdornment: R.isNil(endAdornment) ? endMyadornment : endAdornment
    },
    inputProps: inputProps
  }, textFieldProps));
};

MyInput.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  leftIcon: PropTypes.object,
  rightIcon: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  fullWidth: PropTypes.bool,
  withValidationIcon: PropTypes.bool,
  textFieldProps: PropTypes.object,
  inputProps: PropTypes.object,
  endAdornment: PropTypes.node
} : {};

export default withInput(MyInput);